/* ============================================================
   KapraMehal storefront fixes
   Kept in its own file (NOT inside custom_js.js.liquid) on purpose:
   the theme's Custom JS setting (Theme Customizer > Custom JS)
   currently contains a JavaScript syntax error, which silently
   breaks the entire compiled assets/custom_js.js bundle (a single
   parse error kills the whole script tag - nothing in that file
   runs, including anything appended after it). Keeping these
   fixes in a separate file/script tag means they keep working
   regardless of that unrelated legacy bug.
   ============================================================ */

/* --- Fix 1: de-duplicate WhatsApp order button ---
   Two WhatsApp "Order" buttons can exist on product pages:
   1) #km-wa-order-btn - rendered server-side in
      snippets/product_page_area.liquid with the real product
      title/price. This is the correct one.
   2) #km-wa-btn - if ever injected by other custom JS, this
      removes the duplicate whenever the real one is present. */
(function(){
  function kmRemoveDupeWaBtn(){
    var dupe = document.getElementById('km-wa-btn');
    var real = document.getElementById('km-wa-order-btn');
    if (dupe && real) { dupe.parentNode && dupe.parentNode.removeChild(dupe); }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', kmRemoveDupeWaBtn);
  } else {
    kmRemoveDupeWaBtn();
  }
  window.addEventListener('load', kmRemoveDupeWaBtn);
})();

/* --- Fix 2: relabel native "Buy it now" express button to promote COD ---
   Only targets the UNBRANDED fallback button
   (shopify-payment-button__button--unbranded), which is a plain <button>
   Shopify renders when no Shop Pay / PayPal / Google Pay express option is
   available for the visitor. Branded express buttons are intentionally left
   untouched - their labels/logos are locked by Shopify and the payment
   provider's brand guidelines and must not be altered.
   A MutationObserver re-applies the label whenever Shopify's
   <shopify-buy-it-now-button> web component re-renders the button. */
(function(){
  var KM_LABEL = 'ORDER NOW WITH CASH ON DELIVERY';
  function kmRelabelBuyNow(){
    var btns = document.querySelectorAll('.shopify-payment-button__button--unbranded');
    for (var i = 0; i < btns.length; i++) {
      if (btns[i].textContent.trim() !== KM_LABEL) {
        btns[i].textContent = KM_LABEL;
      }
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', kmRelabelBuyNow);
  } else {
    kmRelabelBuyNow();
  }
  window.addEventListener('load', kmRelabelBuyNow);
  var kmBuyNowObserver = new MutationObserver(function(){ kmRelabelBuyNow(); });
  kmBuyNowObserver.observe(document.documentElement, { childList: true, subtree: true, characterData: true });
})();

/* --- Fix 3: keep the cart drawer's "N items" heading in sync ---
   The drawer heading (snippets/cart_widget_side.liquid) prints the count with
   Liquid: "Shopping cart - {{ cart.item_count }} items". That heading sits
   OUTSIDE the container the theme's JS rebuilds, so unlike the item rows it is
   never re-rendered -- it keeps whatever value the page was first served with.
   Land on a page with an empty cart, add four things, and the heading still
   reads "0 items".

   The theme already maintains an accurate live counter in the header
   (.basel-cart-number.cartCount) and updates it on every AJAX cart change, so
   this simply mirrors that number into the drawer heading instead of
   re-implementing any cart logic or firing another /cart.js request. A
   MutationObserver on the counter keeps it in step with add / remove /
   quantity changes.

   Note: this is deliberately the only piece of the cart-drawer work that needed
   JavaScript. Everything else (labels, hidden blocks, layout) is CSS, which
   survives the JS rebuild on its own -- but a number that has to change at
   runtime cannot be done in CSS. */
(function(){
  var LIVE_SELECTOR = '.basel-cart-number.cartCount, .basel-cart-number, .cartCount';

  function kmReadLiveCount(){
    var live = document.querySelector(LIVE_SELECTOR);
    if (!live) { return null; }
    var digits = (live.textContent || '').replace(/[^0-9]/g, '');
    if (digits === '') { return null; }
    var n = parseInt(digits, 10);
    return isNaN(n) ? null : n;
  }

  function kmSyncCartCount(){
    var targets = document.querySelectorAll('.km-cart-count');
    if (!targets.length) { return; }
    var n = kmReadLiveCount();
    if (n === null) { return; }
    var text = ' · ' + n + ' item' + (n === 1 ? '' : 's');
    for (var i = 0; i < targets.length; i++) {
      if (targets[i].textContent !== text) { targets[i].textContent = text; }
    }
  }

  function kmInitCartCountSync(){
    kmSyncCartCount();
    var live = document.querySelector(LIVE_SELECTOR);
    if (live && window.MutationObserver) {
      new MutationObserver(kmSyncCartCount).observe(live, {
        childList: true,
        characterData: true,
        subtree: true
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', kmInitCartCountSync);
  } else {
    kmInitCartCountSync();
  }
  window.addEventListener('load', kmSyncCartCount);
})();
